// extracted by mini-css-extract-plugin
export default {"clickable":"FileTable_clickable__7YsbF"};